/**
 * Heading reveal (top → bottom) on scroll — GSAP + ScrollTrigger.
 * Inspired by supernovaenergy.pt line-mask transitions.
 */
(function () {
  'use strict';

  var SELECTOR = [
    'main.page-body .homepage-intro-heading',
    'main.page-body .sobre-mission-text',
    'main.page-body .lt-hero-intro',
    'main.page-body .lt-ensaios-intro',
    'main.page-body .ep-hero-intro',
    'main.page-body .ep-equipa-intro',
  ].join(', ');

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function hasGsap() {
    return typeof window.gsap !== 'undefined' &&
      typeof window.ScrollTrigger !== 'undefined';
  }

  function getLinesFromHeading(el) {
    var html = (el.innerHTML || '').trim();
    if (!html) {
      return [];
    }

    if (/<br\s*\/?>/i.test(html)) {
      return html.split(/<br\s*\/?>/i).map(function (part) {
        var tmp = document.createElement('div');
        tmp.innerHTML = part;
        return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
    }

    var text = (el.textContent || '').replace(/\r/g, '');
    if (/\n/.test(text)) {
      return text.split('\n').map(function (line) {
        return line.replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
    }

    var single = text.replace(/\s+/g, ' ').trim();
    return single ? [single] : [];
  }

  function wrapHeadingLines(el, lines) {
    el.classList.add('heading-reveal');
    el.setAttribute('data-heading-reveal', '');

    var frag = document.createDocumentFragment();
    lines.forEach(function (line) {
      var lineWrap = document.createElement('span');
      lineWrap.className = 'heading-reveal-line';

      var inner = document.createElement('span');
      inner.className = 'heading-reveal-inner';
      inner.textContent = line;

      lineWrap.appendChild(inner);
      frag.appendChild(lineWrap);
    });

    el.innerHTML = '';
    el.appendChild(frag);
    return el.querySelectorAll('.heading-reveal-line');
  }

  function shouldSkip(el) {
    if (!el) {
      return true;
    }
    if (el.hasAttribute('data-heading-reveal') || el.hasAttribute('data-heading-reveal-skip')) {
      return true;
    }
    var text = (el.textContent || '').replace(/\s/g, '');
    return !text.length;
  }

  function initHeadingReveal() {
    if (prefersReducedMotion() || !hasGsap()) {
      return;
    }

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    var headings = document.querySelectorAll(SELECTOR);
    headings.forEach(function (heading) {
      if (shouldSkip(heading)) {
        return;
      }

      var lines = getLinesFromHeading(heading);
      if (!lines.length) {
        return;
      }

      var lineMasks = wrapHeadingLines(heading, lines);
      if (!lineMasks.length) {
        return;
      }

      // Máscara abre de cima para baixo (inset no fundo); o texto não se desloca.
      gsap.set(lineMasks, { clipPath: 'inset(0% 0% 100% 0%)' });

      gsap.to(lineMasks, {
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: 1.55,
        ease: 'power3.out',
        stagger: lines.length > 1 ? 0.2 : 0,
        scrollTrigger: {
          trigger: heading,
          start: 'top center',
          once: true,
          invalidateOnRefresh: true,
        },
      });
    });

    window.ScrollTrigger.refresh();
  }

  function onReady() {
    initHeadingReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
